// =========== plugin import =========== //
import React, { useState, useRef, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCircleInfo, faCheck } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import axios from 'axios'
import { Modal } from 'antd';
import Select from 'react-select'
// =========== component import =========== //
import ValidationMessage from '../../../../component/common/ValidationMessage';
import { ValidateEmail, safeDecrypt, refreshCaptcha } from '../../../../component/common/Helper';
import CommonTermsAndConditions from '../../component/CommonTermsAndConditions';
import AlertMessage from '../../../../component/common/AlertMessage';
import { MenuComponent } from '../../../../../_template/assets/ts/components/MenuComponent';
import ButtonLoader from '../../../../component/common/ButtonLoader';
import { countryList, currencyList, countryCodeList } from '../../../../constants/selectOptions';

const BusinessSignUp = () => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }, []);
    const successMessageRender = useRef(null);
    const domainName = window.location.hostname;
    // -------- define all state ------- //
    const[businessRegData, setBusinessRegData] = useState({
        account_name: "",
        account_email: "",
        password: "",
        confirm_password: "",
        contact_title: "",
        contact_full_name: "",
        contact_organization_name: "",
        contact_registered_address: "",
        country_code: null,
        contact_primary_number: "",
        contact_secondary_number: "",
        contact_organization_website: "",
        billing_title: "",
        billing_full_name: "",
        billing_email: "",
        billing_country: null,
        currency: null,
        billing_address: "",
        access_url: "",
    });
    const [businessRegFormError, setBusinessRegFormError] = useState({});
    const [isReadAllTermsAndConditions, setIsReadAllTermsAndConditions] = useState(false);
    const [acceptAllTAC, setAcceptAllTAC] = useState(false);
    const [passwordIsShow, setPasswordIsShow] = useState(false);
    const [confirmPasswordIsShow, setConfirmPasswordIsShow] = useState(false);
    const [showButtonLoader, setShowButtonLoader] = useState(false);
    const [showCheckEmailBtnLoader, setShowCheckEmailBtnLoader] = useState(false);
    const [verificationCode, setVerificationCode] = useState('')
    const [verificationModalIsOpen, setVerificationModalIsOpen] = useState(false);
    const [isMailSent, setIsMailSent] = useState(false);
    const [isShowEmailValidateBtn, setIsShowEmailValidateBtn] = useState(true);
    // -------- end define all state ------- //

    const acceptTermsAndConditionsOnClick = () => {
        setIsReadAllTermsAndConditions(true)
        setAcceptAllTAC(true)
    }
    const validateField = (name, value) => {
        let error = "";
        if (name === "account_name") {
            if (!value) {
                error = "Account name is required";
            } 
        }
        if (name === "account_email") {
            if (!value) {
                error = "Account email is required";
            }
            else if(!ValidateEmail(value)){
                error = "Invalid email address";
            }
        }
        if (name === "password") {
            if (!value) {
                error = "Password is required";
            }
            else if(businessRegData.confirm_password !== ''){
                if(value !== businessRegData.confirm_password){
                    setBusinessRegFormError((prevErrors) => ({
                        ...prevErrors,
                        'confirm_password': `Password and confirmation password doesn't match.`,
                    }));
                }
                else{
                    setBusinessRegFormError((prevErrors) => ({
                        ...prevErrors,
                        'confirm_password': ``,
                    }));
                }
            }
        }
        if (name === "confirm_password") {
            if (!value) {
                error = "Confirm password is required";
            }
            else if(value !== businessRegData.password){
                error = "Password and confirmation password doesn't match.";
            }
        }
        if (name === "contact_full_name") {
            if (!value) {
                error = "Full name is required";
            } 
        }
        if (name === "contact_organization_name") {
            if (!value) {
                error = "Organization name is required";
            } 
        }
        if (name === "contact_registered_address") {
            if (!value) {
                error = "Registered address is required";
            } 
        }

        if(name === 'country_code'){
            if(!value){
                error = "Country code is required";
            }
        }

        if (name === "contact_primary_number") {
            if (!value) {
                error = "Primary number is required";
            } 
        }
        if (name === "billing_full_name") {
            if (!value) {
                error = "Billing full name is required";
            } 
        }
        if (name === "billing_email") {
            if (!value) {
                error = "Billing email is required";
            }
            else if(!ValidateEmail(value)){
                error = "Invalid email address";
            }
        }
        if(name === 'billing_country'){
            if(!value){
                error = "Billing country is required";
            }
        }
        if(name === 'currency'){
            if(!value){
                error = "Currency is required";
            }
        }
        if (name === "billing_address") {
            if (!value) {
                error = "Billing address is required";
            } 
        }
        if (name === "access_url") {
            if (!value) {
                error = "Access URL is required";
            } 
        }
        return error; 
    }

    const inputChangeHandler = (selectedOption, actionMeta) => {
        if(selectedOption?.target){
            // ------ manage input and checkbox ------ //
            const { name, value, } = selectedOption.target;
            let fieldValue = value;
            if (name === 'contact_primary_number' || name === 'contact_secondary_number'){
                fieldValue = value.replace(/\D/g, '');
            }
            else if(name === 'access_url'){
                fieldValue = value.toLowerCase().replace(/[^a-z0-9]/g, '');
            }
            const fieldError = validateField(name, fieldValue);
            setBusinessRegFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setBusinessRegData((prevData) => ({
                ...prevData,
                [name]: fieldValue,
            }));
        }
        else if(actionMeta?.name){
            // ------- manage select field --------- //
            const { name } = actionMeta;
            if(name === 'billing_country' || name === 'currency' || name === 'country_code'){
                setBusinessRegData((prevData) => ({
                    ...prevData,
                    [name]: selectedOption,
                }));
            }
            const fieldError = validateField(name, selectedOption?.value);
            setBusinessRegFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
        }
    }

    // --------- validate email ---------- //
    const validateEmailOnClick = async () => {

        if(verificationCode !== ''){
            setVerificationModalIsOpen(true)
            return
        }

        const errors = {};
        if (!businessRegData.account_email?.trim()) {
            errors.account_email = 'Account email is required';
        }
    
        if (!businessRegData.account_name?.trim()) {
            errors.account_name = 'Account name is required';
        }
        setBusinessRegFormError(errors);

        if(Object.keys(errors).length > 0){
            return
        }
        setShowCheckEmailBtnLoader(true)
        const captchaToken = await refreshCaptcha();
        const api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
        const api_params = {
            entered_email : businessRegData.account_email,
            entered_name : businessRegData.account_name,
            captcha_token: captchaToken
        }
        await axios.post(`${api_base_url}api/sent-verification-code`, api_params, api_headers)
        .then(async (res) => {
            setShowCheckEmailBtnLoader(false)
            if(res.data.status === 'success') {
                setVerificationModalIsOpen(true)
                setIsMailSent(true)
                const _token = res.data.data._token
                const decrypted = safeDecrypt({
                    encryptedData : _token,
                    base64Key : 'gT#7@uZ$9LmR8qV1',
                    base64Iv : 'X7r#zP@9gL!q1VbT'
                });
                setVerificationCode(decrypted)
            } else if(res.data.status === 'error') {
                toast.error(res.data.message);
            }
            
        })
        .catch((error) => {
            console.error(error);
            setShowCheckEmailBtnLoader(false)
        })
    }

    useEffect(() => {
        if(verificationCode === '') return;
        const timer = setTimeout(() => {
            setVerificationCode('')
        }, 10 * 60 * 1000); // 10 minutes 
        return () => clearTimeout(timer);
    }, [verificationCode]);

    const handleSubdomainInput = async () => {
        if(businessRegData.access_url === ''){
            return
        }
        const api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
        const api_params = {
            sub_domain: businessRegData.access_url
        }
        await axios.post(`${api_base_url}api/valid-subdomains`, api_params, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                if(res.data.data.length > 0){
                    setBusinessRegFormError((prevErrors) => ({
                        ...prevErrors,
                        ['access_url']: 'This application URL is already in use. Please choose a different one.',
                    }));
                }
            } else if(res.data.status === 'error') {
                toast.error("There is an error");
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }

    const saveDetailsOnClick = async () => {
        if(!isReadAllTermsAndConditions){
            toast.warning("Read the terms and conditions first.");
            return
        }
        if(!acceptAllTAC){
            return
        }
        if(!isMailSent){
            toast.warning("Email is not verified");
            return
        }
        const newErrors = { ...businessRegFormError };
        for (const key in businessRegData) {
            const fieldError = validateField(key, businessRegData[key]);
            if (!newErrors[key]) {
                newErrors[key] = fieldError;
            }
        }
        setBusinessRegFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setShowButtonLoader(true)
            const captchaToken = await refreshCaptcha();
            const api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            const api_params = {
                reg_data : businessRegData,
                captcha_token: captchaToken
            }
            await axios.post(`${api_base_url}api/business-signup`, api_params, api_headers)
            .then(async (res) => {
                setShowButtonLoader(false)
                if(res.data.status === 'success') {
                    successMessageRender.current.innerHTML = `
                        <div class="alert alert-success d-flex align-items-center p-5">
                            <div class="d-flex flex-column">
                                <h4 class="mb-1 text-gray-800 fs-5">
                                    Your account has been created
                                </h4>
                                <span class='text-gray-700'>
                                    Please
                                    <a href='${res.data.data.subdomainName}' class='mx-1 text-primary' target='blank'>
                                        sign in
                                    </a>
                                    to continue.
                                    We’ve sent a confirmation email to your registered email address.
                                </span>
                            </div>
                        </div>
                    `;
                    setBusinessRegData({
                        account_name: "",
                        account_email: "",
                        password: "",
                        confirm_password: "",
                        contact_title: "",
                        contact_full_name: "",
                        contact_organization_name: "",
                        contact_registered_address: "",
                        country_code: null,
                        contact_primary_number: "",
                        contact_secondary_number: "",
                        contact_organization_website: "",
                        billing_title: "",
                        billing_full_name: "",
                        billing_email: "",
                        billing_country: null,
                        currency: null,
                        billing_address: "",
                        access_url: "",
                    });
                    setIsReadAllTermsAndConditions(false)
                    setAcceptAllTAC(false)
                    setIsMailSent(false)
                } else if(res.data.status === 'error') {
                    toast.error(res.data.message);
                }
            })
            .catch((error) => {
                console.error(error);
            })
        }
    }

    // -------- verification modal manage ----------- //
    const inputRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    const [verificationValus, setVerificationValus] = useState(['', '', '', '', '']);

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (!/^\d?$/.test(value)) return;
        const newValues = [...verificationValus];
        newValues[index] = value;
        setVerificationValus(newValues);
        if (value && index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };
    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !verificationValus[index] && index > 0) {
            const newValues = [...verificationValus];
            newValues[index - 1] = '';
            setVerificationValus(newValues);
            inputRefs[index - 1].current.focus();
        }
    };
    useEffect(() => {
        if (inputRefs[0]?.current) {
            inputRefs[0].current.focus();
        }
    }, [verificationModalIsOpen]);

    const verificationCodeIsMatch = () => {
        const enteredValue = verificationValus.join('');
        if(enteredValue === verificationCode){
            toast.success("Your email has been successfully verified.");
            setVerificationModalIsOpen(false)
            setIsShowEmailValidateBtn(false)
        }
        else{
            toast.error("Your varification code is invalid");
        }
    }
    const isAllFilled = verificationValus.every((val) => val !== '');
    return (
        <>
            <style>
                {
                    `
                        .react-select__single-value {
                            height: 15px
                        }
                    `
                }
            </style>
            <section className="hero-area hero-area-background">
                <div className="container">
                    <div className="text-center px-20">
                        <div className="section-heading">
                            <div className="title-wrapper">
                                <h2 className="section-title has_fade_anim fs-4x text-grad-1 pb-6">
                                    Organization Registration
                                </h2>
                                <div className="section-title has_fade_anim fw-bold fs-1 mt-2 lh-2 text-grad pb-1">
                                    Sign-up now
                                </div>
                                <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                                    If you are already registered, Sign-in
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='mt-20'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card border border-dashed border-primary p-10'>
                                <div className="row mb-5">
                                    <div className='col-md-12'>
                                        <div className='card card-flush '>
                                            <div className='card-header ps-0'>
                                                <h3 className="card-title align-items-start flex-column">
                                                    <span className="card-label fw-bold text-gray-900 fs-2">
                                                        Account
                                                    </span>
                                                </h3>
                                            </div>
                                            <div className='card-body p-0'>
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Account Name
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.account_name ? 'is-invalid' : ''}`} 
                                                                placeholder="Enter account name"
                                                                name="account_name"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.account_name}
                                                                disabled={isMailSent}
                                                            />
                                                            {businessRegFormError.account_name && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.account_name}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Password
                                                            </label>
                                                           <div className="input-group mb-5">
                                                                <input 
                                                                    type="text" 
                                                                    className={`form-control h-50px ${!passwordIsShow ? 'inp-secure' : '' } ${businessRegFormError.password ? 'is-invalid' : ''} `}
                                                                    placeholder="Enter password" 
                                                                    name='password'
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.password}
                                                                />
                                                                <span className="input-group-text">
                                                                    <FontAwesomeIcon 
                                                                        icon={passwordIsShow?faEyeSlash : faEye}
                                                                        className='fs-4 cursor-pointer'
                                                                        onClick={() => setPasswordIsShow(!passwordIsShow)}
                                                                    />
                                                                </span>
                                                            </div>
                                                            {businessRegFormError.password && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.password}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Confirm Password
                                                            </label>
                                                           <div className="input-group mb-5">
                                                                <input 
                                                                    type="text" 
                                                                    className={`form-control h-50px ${!confirmPasswordIsShow ? 'inp-secure' : '' } ${businessRegFormError.confirm_password ? 'is-invalid' : ''} `}
                                                                    placeholder="Enter confirm password" 
                                                                    name='confirm_password'
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.confirm_password}
                                                                />
                                                                <span className="input-group-text">
                                                                    <FontAwesomeIcon 
                                                                        icon={confirmPasswordIsShow?faEyeSlash : faEye}
                                                                        className='fs-4 cursor-pointer'
                                                                        onClick={() => setConfirmPasswordIsShow(!confirmPasswordIsShow)}
                                                                    />
                                                                </span>
                                                            </div>
                                                            {businessRegFormError.confirm_password && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.confirm_password}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-8'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Account email
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.account_email ? 'is-invalid' : ''}`} 
                                                                placeholder="Enter account email"
                                                                name="account_email"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.account_email}
                                                                disabled={isMailSent}
                                                            />
                                                            {businessRegFormError.account_email && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.account_email}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4 m-auto mb-10 text-end'>
                                                        {
                                                            isShowEmailValidateBtn && 
                                                            <div
                                                                className={`btn btn-dark br-50 btn-lg ${showCheckEmailBtnLoader && 'disabled'}`}
                                                                onClick={validateEmailOnClick}
                                                            >
                                                                {
                                                                    showCheckEmailBtnLoader ? 
                                                                    <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 
                                                                    'Validate Email'
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className='col-md-12'>
                                        <div className='card card-flush '>
                                            <div className='card-header ps-0'>
                                                <h3 className="card-title align-items-start flex-column">
                                                    <span className="card-label fw-bold text-gray-900 fs-2">
                                                        Primary Contact Information
                                                    </span>
                                                </h3>
                                            </div>
                                            <div className='card-body p-0'>
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="form-label">
                                                                Title
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.contact_title ? 'is-invalid' : ''}`} 
                                                                placeholder="Enter title"
                                                                name="contact_title"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.contact_title}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Full Name
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.contact_full_name ? 'is-invalid' : ''}`} 
                                                                placeholder="Enter full name"
                                                                name="contact_full_name"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.contact_full_name}
                                                            />
                                                            {businessRegFormError.contact_full_name && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.contact_full_name}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Organization Name
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.contact_organization_name ? 'is-invalid' : ''}`} 
                                                                placeholder="Enter organization name"
                                                                name="contact_organization_name"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.contact_organization_name}
                                                            />
                                                            {businessRegFormError.contact_organization_name && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.contact_organization_name}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Registered Address
                                                            </label>
                                                                <>
                                                                    <span 
                                                                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                                                        data-sai-menu-trigger='click'
                                                                        data-sai-menu-placement='bottom-end'
                                                                        data-sai-menu-flip='top-end'
                                                                    >
                                                                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                                                    </span>
                                                                    <div className="menu menu-sub menu-sub-dropdown w-250px w-md-250px p-3" data-sai-menu="true">
                                                                        <div className='row'>
                                                                            <div className='col-md-12 p-5'>
                                                                                <span className="fw-semibold text-gray-600 fs-6 d-block lh-sm">
                                                                                    For Organizations provide Registered Address. For individuals, provide Residential Address
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            <textarea
                                                                type="text" 
                                                                className={`form-control ${businessRegFormError.contact_registered_address ? 'is-invalid' : ''}`}
                                                                placeholder="Enter address"
                                                                name="contact_registered_address"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.contact_registered_address}
                                                                rows={6}
                                                            ></textarea>
                                                            {businessRegFormError.contact_registered_address && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.contact_registered_address}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-8'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <label className="required form-label">
                                                                    Country code
                                                                </label>
                                                                <Select
                                                                    className="react-select-styled"
                                                                    classNamePrefix="react-select"
                                                                    options={countryCodeList}
                                                                    placeholder="Select country code"
                                                                    name='country_code'
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.country_code}
                                                                />
                                                                {businessRegFormError.country_code && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.country_code}/>}
                                                            </div>
                                                            <div className='col-md-4'>
                                                                <label className="required form-label">
                                                                    Primary contact number
                                                                </label>
                                                                <>
                                                                    <span 
                                                                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                                                        data-sai-menu-trigger='click'
                                                                        data-sai-menu-placement='bottom-end'
                                                                        data-sai-menu-flip='top-end'
                                                                    >
                                                                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                                                    </span>
                                                                    <div className="menu menu-sub menu-sub-dropdown w-250px w-md-250px p-3" data-sai-menu="true">
                                                                        <div className='row'>
                                                                            <div className='col-md-12 p-5'>
                                                                                <span className="fw-semibold text-gray-600 fs-6 d-block lh-sm">
                                                                                    Please provide your handphone numbers where you can be reached directly.
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                <input
                                                                    type="text" 
                                                                    className={`form-control h-50px ${businessRegFormError.contact_primary_number ? 'is-invalid' : ''}`} 
                                                                    placeholder="Enter primary contact"
                                                                    name="contact_primary_number"
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.contact_primary_number}
                                                                />
                                                                {businessRegFormError.contact_primary_number && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.contact_primary_number}/>}
                                                            </div>
                                                            <div className='col-md-4'>
                                                                <label className="form-label">
                                                                    Secondary contact number
                                                                </label>
                                                                <>
                                                                    <span 
                                                                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                                                        data-sai-menu-trigger='click'
                                                                        data-sai-menu-placement='bottom-end'
                                                                        data-sai-menu-flip='top-end'
                                                                    >
                                                                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                                                    </span>
                                                                    <div className="menu menu-sub menu-sub-dropdown w-250px w-md-250px p-3" data-sai-menu="true">
                                                                        <div className='row'>
                                                                            <div className='col-md-12 p-5'>
                                                                                <span className="fw-semibold text-gray-600 fs-6 d-block lh-sm">
                                                                                    Please provide the handphone numbers where you can be reached directly.
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                <input
                                                                    type="text" 
                                                                    className={`form-control h-50px ${businessRegFormError.contact_secondary_number ? 'is-invalid' : ''}`} 
                                                                    placeholder="Enter secondary contact"
                                                                    name="contact_secondary_number"
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.contact_secondary_number}
                                                                />
                                                            </div>
                                                            <div className='col-md-12 mt-9'>
                                                                <label className="form-label">
                                                                    Organization Website
                                                                </label>
                                                                <input
                                                                    type="text" 
                                                                    className={`form-control h-50px ${businessRegFormError.contact_organization_website ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter organization website"
                                                                    name="contact_organization_website"
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.contact_organization_website}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className='col-md-12'>
                                        <div className='card card-flush '>
                                            <div className='card-header ps-0'>
                                                <h3 className="card-title align-items-start flex-column">
                                                    <span className="card-label fw-bold text-gray-900 fs-2">
                                                        Billing Contact Information
                                                    </span>
                                                </h3>
                                            </div>
                                            <div className='card-body p-0'>
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="form-label">
                                                                Title
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.billing_title ? 'is-invalid' : ''}`}
                                                                placeholder="Enter billing title"
                                                                name="billing_title"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.billing_title}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Full Name
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.billing_full_name ? 'is-invalid' : ''}`}
                                                                placeholder="Enter billing name"
                                                                name="billing_full_name"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.billing_full_name}
                                                            />
                                                            {businessRegFormError.billing_full_name && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.billing_full_name}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Email
                                                            </label>
                                                            <input
                                                                type="text" 
                                                                className={`form-control h-50px ${businessRegFormError.billing_email ? 'is-invalid' : ''}`} 
                                                                placeholder="Enter billing email"
                                                                name="billing_email"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.billing_email}
                                                            />
                                                            {businessRegFormError.billing_email && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.billing_email}/>}
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='row'>
                                                            <div className='col-md-12 mb-7'>
                                                                <label className="form-label required">
                                                                    Billing Country
                                                                </label>
                                                                <Select
                                                                    className="react-select-styled"
                                                                    classNamePrefix="react-select"
                                                                    options={countryList}
                                                                    placeholder="Select billing country"
                                                                    name='billing_country'
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.billing_country}
                                                                />
                                                                {
                                                                    businessRegFormError.billing_country && 
                                                                    <ValidationMessage 
                                                                        className='text-danger mt-2 lh-sm' 
                                                                        message ={businessRegFormError.billing_country}
                                                                    />
                                                                }
                                                            </div>
                                                            <div className='col-md-12'>
                                                                <label className="form-label required">
                                                                    Currency
                                                                </label>
                                                                <Select
                                                                    className="react-select-styled"
                                                                    classNamePrefix="react-select"
                                                                    options={currencyList}
                                                                    placeholder="Select currency"
                                                                    name='currency'
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.currency}
                                                                />
                                                                {
                                                                    businessRegFormError.currency && 
                                                                    <ValidationMessage 
                                                                        className='text-danger mt-2 lh-sm' 
                                                                        message ={businessRegFormError.currency}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-8'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Billing Address
                                                            </label>
                                                            <textarea 
                                                                type="text" 
                                                                className={`form-control ${businessRegFormError.billing_address ? 'is-invalid' : ''}`} 
                                                                placeholder="Enter billing address"
                                                                name="billing_address"
                                                                onChange={inputChangeHandler}
                                                                value={businessRegData.billing_address}
                                                                rows={5}
                                                            ></textarea>
                                                            {businessRegFormError.billing_address && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.billing_address}/>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-5">
                                    <div className='col-md-12'>
                                        <div className='card card-flush '>
                                            <div className='card-header ps-0'>
                                                <h3 className="card-title align-items-start flex-column">
                                                    <span className="card-label fw-bold text-gray-900 fs-2">
                                                        Display URL
                                                    </span>
                                                </h3>
                                            </div>
                                            <div className='card-body p-0'>
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className="mb-10">
                                                            <label className="required form-label">
                                                                Access URL
                                                            </label>
                                                            <>
                                                                <span 
                                                                    className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                                                                    data-sai-menu-trigger='click'
                                                                    data-sai-menu-placement='bottom-end'
                                                                    data-sai-menu-flip='top-end'
                                                                >
                                                                    <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                                                                </span>
                                                                <div className="menu menu-sub menu-sub-dropdown w-250px w-md-250px p-3" data-sai-menu="true">
                                                                    <div className='row'>
                                                                        <div className='col-md-12 p-5'>
                                                                            <span className="fw-semibold text-gray-600 fs-6 d-block lh-sm">
                                                                                This is the personalized URL from where you will access the Portal.
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            <div className="input-group">
                                                                <input
                                                                    type="text" 
                                                                    className={`form-control h-50px ${businessRegFormError.access_url ? 'is-invalid' : ''}`} 
                                                                    placeholder="Application URL"
                                                                    name="access_url"
                                                                    onChange={inputChangeHandler}
                                                                    value={businessRegData.access_url}
                                                                    onBlur={handleSubdomainInput}
                                                                />
                                                                <span className="input-group-text" id="basic-addon2">
                                                                    .{domainName}
                                                                </span>
                                                            </div>
                                                            {businessRegFormError.access_url && <ValidationMessage className='text-danger mt-2 lh-sm' message ={businessRegFormError.access_url}/>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row mb-10'>
                                    <div className='col-md-6'>
                                        {
                                            isReadAllTermsAndConditions && 
                                            <div className="form-check form-check-solid mt-3">
                                                <input 
                                                    className="form-check-input bg-dark" 
                                                    type="checkbox" 
                                                    id="acTACch" 
                                                    name="book_terms_and_conditions" 
                                                    value=""
                                                    checked={acceptAllTAC}
                                                    onChange={ (event) => setAcceptAllTAC(event.target.checked)}
                                                />
                                                <label className="form-check-label mt-1 text-gray-700" htmlFor="acTACch">
                                                    I accept all the terms and conditions
                                                </label>
                                            </div>
                                        }
                                        {
                                            !isReadAllTermsAndConditions && 
                                            <div className="form-check form-check-solid mt-3 ps-0">
                                                <label 
                                                    className="form-check-label mt-1 text-primary fw-bold cursor-pointer"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#termsAndConditionsModal"
                                                >
                                                    Click here to read and accept TruVoice's Terms & Conditions to sign up
                                                </label>
                                            </div>
                                        }
                                    </div>
                                    <div className='col-md-6 text-end'>
                                        <button 
                                            className={`btn btn-dark`}
                                            type="button"
                                            onClick={saveDetailsOnClick}
                                            style={{
                                                opacity: acceptAllTAC ? 1 : 0.5
                                            }}
                                            disabled={showButtonLoader}
                                        >
                                            {
                                                showButtonLoader ? 
                                                <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 
                                                'Create Account'
                                            }
                                        </button>
                                        <div className="text-gray-600 text-end fw-semibold fs-6 mt-5">
                                            Already have an account?
                                            <Link
                                                to={'/login'}
                                                className="link-primary ms-1"
                                            >
                                                Sign in
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div ref={successMessageRender}></div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div 
                className="modal fade modal-lg video-modal" 
                id="termsAndConditionsModal" 
                data-bs-backdrop="false" 
                data-bs-keyboard="true"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body p-0 overflow-x-hidden">
                            <div className='row border p-10 br-20'>
                                <div className='col-md-12'>
                                    <div className='text-center'>
                                        <h2 className="section-title fs-2hx text-grad-3">
                                            TruVoice's Terms &amp; Conditions
                                        </h2>
                                        <p className="text my-3 pe-5 fs-3 text-gray-700">
                                            Read all terms and conditions
                                        </p>
                                    </div>
                                </div>
                                <div className='col-md-12 mb-8'>
                                    <CommonTermsAndConditions/>
                                </div>
                                <div className='col-md-12 text-end'>
                                    <button 
                                        className="btn btn-outline btn-outline-dark btn-active-light-dark me-2"
                                        data-bs-dismiss="modal"
                                        type="button"
                                    >
                                        Close
                                    </button>
                                    <button 
                                        className={`btn btn-primary`} 
                                        type="button"
                                        data-bs-dismiss="modal"
                                        onClick={acceptTermsAndConditionsOnClick}
                                    >
                                        Accept
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={verificationModalIsOpen}
                title={null}
                footer={null} 
                width={450}
            >
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="text-center mb-10">
                            <h1 className="text-gray-800 mb-2 fs-2x">
                                Verification
                            </h1>
                            <div className="text-muted fw-semibold fs-5">
                                Please check your email at <span className='text-primary'>{businessRegData.account_email}</span>  and enter the verification code we sent to activate your account.
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className="mb-10">
                            <div className="fw-bold text-start text-dark fs-6 mb-1 ms-1">
                                Enter your 5 digit verification code
                            </div>
                            <div className="d-flex flex-wrap">
                                {inputRefs.map((ref, index) => (
                                    <input
                                        className="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-2 my-2"
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        ref={ref}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        value={verificationValus[index]}
                                    />
                                ))}
                            </div>
						</div>
                    </div>
                    <div className='col-md-12 text-end'>
                        <button 
                            type="button" 
                            className="btn btn-dark me-2" 
                            onClick={()=>{
                                setVerificationModalIsOpen(false)
                                setVerificationValus(['','','','',''])
                            }}
                        >
                            Cancel
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-primary"
                            onClick={verificationCodeIsMatch}
                            disabled={!isAllFilled}
                        >
                            Validate
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export {BusinessSignUp}